<template>
    <div>
        <coupon-write-link v-for="writeLayout in writeLayouts" :writeLayout="writeLayout" :couponData="couponData" :couponType="couponType"></coupon-write-link>
    </div>
</template>

<script>
import CouponWriteLink from "@/components/coupon/CouponWriteLink";
import alertMixins from "@/mixins/alertMixins";
import EventBus from "@/utils/event-bus";
import util from "@/mixins/util";
import couponValidator from "@/mixins/validators/couponValidator";
import elFileMixins from "@/mixins/elFileMixins";
import CouponUtil from "@/components/coupon/CouponUtil";
import Swal from 'sweetalert2'


export default {
    name: "CouponWriteComponent",
    mixins: [alertMixins, CouponUtil, couponValidator, elFileMixins],
    components: {CouponWriteLink},
    inject: ['changeLoading'],
    provide() {
    return {
        couponWriteSetData: this.setData,

    }
    },
    props: {
        couponType: {},
        couponKey: {default: 0},
    },
    data() {
    return {
        writeLayouts: [],
        writeFunc: '',
        writeApiParamSet: {},
        parsingData: {},
        writeFailTypes: {},
        couponData: {},
        fileType: '',
        detailApiParamsSet: {},
        writeKeyName: '',
        getFunc: '',
        deleteFunc: '',
        deleteKeyName: '',
        deleteReason: '',
        //필터
    }
    },
    created() {
    this.initFilterConfig();
    if (this.couponKey === 0) {
        this.initTemplateConfig();
    } else {
        // api가 연결 된다면 실행되는 메소드입니다.
        this.getCoupon();
    }
    },
    mounted() {
        EventBus.$on('writeCoupon', this.writeCoupon);
        EventBus.$on('deleteCoupon', this.deleteCoupon);
    },
    beforeDestroy() {
        EventBus.$off('writeCoupon');
        EventBus.$off('deleteCoupon');
    },
    destroyed() {
    },
    computed: {},
    methods: {
        setData(key, value) {
            this[key] = value;
        },
        initTemplateConfig() {
            let configCoupon = this.returnCouponConfig(this.couponType);
            this.writeLayouts = configCoupon.writeLayouts;
        },
        initFilterConfig() {
            let configCoupon = this.returnCouponConfig(this.couponType);
            this.writeFunc = configCoupon.writeFunc;
            this.writeApiParamSet = configCoupon.writeApiParamSet;
            this.parsingData = configCoupon.parsingData;
            this.writeFailTypes = configCoupon.writeFailTypes;
            this.fileType = configCoupon.fileType;
            this.detailApiParamsSet = configCoupon.detailApiParamsSet;
            this.writeKeyName = configCoupon.writeKeyName;
            this.getFunc = configCoupon.getFunc;
            this.deleteFunc = configCoupon.deleteFunc;
            this.deleteKeyName = configCoupon.deleteKeyName;
            this.deleteReason = configCoupon.deleteReason;
            
        },
        getCoupon() {
            let params = JSON.parse(JSON.stringify(this.detailApiParamsSet));
            !util.isEmpty(this.writeKeyName)? params[this.writeKeyName] = this.couponKey : params.id =this.couponKey;
            
            try {
                this.$api.$coupon[this.getFunc](params).then(res => res.Data.Result).then(res => {
                    if(res.Info.type == 1) {
                        if(res.List.length > 0){
                            this.couponData = res.List[0]
                        } else {
                            this.createAlert({
                                content: '해당 쿠폰의 상세를 불러올 수 없습니다.',
                                hide: () => {
                                    this.$router.back();
                                }
                            })
                        }
                    } else {
                        this.$router.back();
                        this.errorAlert(res.Info.reason);
                    }
                    this.initTemplateConfig();
                })
            } catch(e) {
                this.changeLoading(false);
                console.log(e);
            }

            
        },
        writeCoupon() {
            let dataArr = Object.keys(this.parsingData);
            this.$validate(dataArr).then(success => {
                if (!success) {
                    this.errorAlert('필수정보를 모두 입력해주세요.');
                    return;
                }

                let params = JSON.parse(JSON.stringify(this.writeApiParamSet))
                
                dataArr.forEach(dataKey => {
                    params[this.parsingData[dataKey]] = this[dataKey];
                })

                if (this.couponKey != 0) {
                    params.c_idx = this.couponKey
                } 

                //일반 이미지
                try {
                    this.$api.$coupon[this.writeFunc](params).then(res => res.Data.Result).then(res => {
                        this.createAlert({
                            title: '',
                            content: this.couponKey !== 0 ? '수정되었습니다.' : '저장되었습니다.',
                            btnText: '확인',
                            hide: () => {
                                this.$router.back();
                                return false;
                            } 
                        })
                    });

                } catch (e) {
                    this.changeLoading(false);
                    console.log(e);
                }
                
            })
        },
        deleteCoupon() {
            Swal.fire({
                title: '삭제 사유',
                text: '쿠폰 삭제 사유를 입력해주세요.',
                confirmButtonText: '확인',
                cancelButtonText: '취소',
                showCancelButton: true,
                inputAutoTrim: false,
                inputPlaceholder: '삭제 사유를 입력해주세요.',
                input: 'text',
                customClass: 'koreanSSam',
                inputValidator: (value) => {
                    if (!value) {
                        return '삭제 사유를 입력해주세요!'
                    }
                },
                preConfirm: (value) => {
                    let params = {}
                    params[this.deleteKeyName] = this.couponKey
                    params[this.deleteReason] = value

                    try {
                        this.$api.$coupon[this.deleteFunc](params).then(res => res.Data.Result).then(res => {
                            if(res.Info.type == 1) {
                                    this.$router.back();
                                    this.errorAlert(res.Info.reason);                            
                                } else {
                                    this.errorAlert(res.Info.reason);
                                }
                        })
                    } catch (e) {
                        this.changeLoading(false);
                            console.log(e);
                    }
                }
            })

            
        }
        
    },
    watch: {},
}
</script>

<style scoped>

</style>
